import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../helper/Context';
import PremiumFeatureModal from './PremiumFeatureModal';

/**
 * PremiumFeatureGate - Shows an upgrade overlay for free tier users.
 * Non-free users see the children normally.
 *
 * @param {React.ReactNode} props.children   - The page content to render
 * @param {string}          props.featureName - Feature name shown in the upsell card
 */
const PremiumFeatureGate = ({ children, featureName = 'This feature' }) => {
  const navigate = useNavigate();
  const { userInfo } = useContext(UserInfo);

  const isFreeUser = !userInfo || userInfo.tier === 'free';

  if (!isFreeUser) {
    return children;
  }

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Blurred, non-interactive page preview */}
      <div style={{ filter: 'blur(2px)', opacity: 0.65, pointerEvents: 'none' }}>
        {children}
      </div>

      {/* Reuse the shared modal card, always shown, "Go Back" navigates back */}
      <PremiumFeatureModal
        show={true}
        onHide={() => navigate(-1)}
        featureName={featureName}
      />
    </div>
  );
};

export default PremiumFeatureGate;

